import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useCart } from '../../contexts/CartContext';
import './CartBadge.css';

interface CartBadgeProps {
  onClick?: () => void;
  className?: string;
}

const CartBadge: React.FC<CartBadgeProps> = ({ onClick, className = '' }) => {
  const { t } = useTranslation();
  const { itemCount } = useCart();

  const label =
    itemCount > 0
      ? t('shop.cart.badgeCount', { count: itemCount })
      : t('shop.cart.badgeEmpty');

  return (
    <Link
      to="/boutique/panier"
      className={`cart-badge ${className}`.trim()}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <FaShoppingCart aria-hidden="true" />
      <AnimatePresence>
        {itemCount > 0 && (
          <motion.span
            key="count"
            className="cart-badge__count"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            transition={{ type: 'spring', stiffness: 500, damping: 25 }}
          >
            {itemCount > 99 ? '99+' : itemCount}
          </motion.span>
        )}
      </AnimatePresence>
    </Link>
  );
};

export default CartBadge;
